export default __webpack_public_path__ + "static/philanthropy-7e4069325cb0f1c80755ee658d6feb5c.png";